import react, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Form as FormLayout, Alert, Button, Spinner } from 'react-bootstrap';
import { OnBlur } from 'react-final-form-listeners';
import { passwordStrength } from 'check-password-strength';

//Components
import { campotexto } from '../campos/campos';

//Actions
import { pesquisa, novoatualiza } from '../../../actions/logingerenciamento/login';

//Helpers
import { setUserGeren, getUserGeren } from '../../../utils/authusuariogerenciamento';

//Helpers
import { setToken } from '../../../utils/tokencidtechapi';

const FormCadastro = (props) => {
    const user = getUserGeren();
    const [email_valido, setEmailValido] = useState(null);
    const [confcadastro, setConfCadastro] = useState(null);

    const handleSubmitForm = async (form) => {
        delete form.id;
        const cadastro = await props.novoatualiza(form);
        if(cadastro.id){

            delete cadastro.password;
            setUserGeren(cadastro);

            setToken(cadastro.token);
            delete cadastro.token;

            setConfCadastro(true);
        }
    }

    const handleEmail = (form) => {
        const email = form.getFieldState('email').value;
        if(email !== ''){
            props.pesquisa({email: form.getFieldState('email').value});
        }
    }
    
    const pesquisaLogin = props.pesquisaLogin;
    useEffect(() => {
        setEmailValido(null);
        setConfCadastro(null);
        if(user&&user.id){
            props.pesquisa({email: user.email});
        }
    },[])

    useEffect(() => {
        
        let emailValidacao = true;
        if(pesquisaLogin[0] && pesquisaLogin[0].id){
            emailValidacao = false;
            if(user&&user.id && user.id===pesquisaLogin[0].id){
                emailValidacao = true;
            }
        }

        setEmailValido(emailValidacao);

    },[pesquisaLogin]);
    
    return (
        <Form
            onSubmit={handleSubmitForm}
            validate={(form) => {

                const errors = {};

                if(!form.codigopromotora){
                    errors.codigopromotora = 'Obrigatório';
                }

                if(!form.name){
                    errors.name = 'Obrigatório';
                }

                if(!form.email){
                    errors.email = 'Obrigatório';
                }

                if(!form.password){
                    errors.password = 'Obrigatório';
                }

                if(form.password){                    
                    if(form.password.length < 6){
                        errors.password = 'Tamanho mínimo de 6 caracteres';
                    }
                    if(passwordStrength(form.password).id < 2){
                        errors.password = 'Senha muito fraca, experimente símbolos e letras maiúsculas!';
                    }
                }

                return errors;
            }}
            initialValues={getUserGeren()}
            render={({form,handleSubmit, errors}) => {          
                console.log(errors);
                return (
                    <form onSubmit={handleSubmit}>
                        {confcadastro!==null?
                        <FormLayout.Row>
                            <Alert variant={`${confcadastro?'success':'warning'}`}>                                
                                {confcadastro?
                                    <>
                                    <Alert.Heading>Parabéns!</Alert.Heading>
                                    <p>
                                        Dados Cadastrados e Atualizados
                                    </p>
                                    <hr />
                                    <Button type="button" onClick={() => props.history.push('/gerenciamento/dashboard')} variant="outline-primary">
                                        Continuar
                                    </Button>
                                    </>
                                    :
                                    'Ocorreu algum Problema!'}
                            </Alert>
                        </FormLayout.Row>
                        :    
                        <>
                        <FormLayout.Row>
                            <Field type='text' name='codigopromotora' label='Código da Promotora' component={campotexto} />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <Field type='text' name='name' label='Nome' component={campotexto} />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <Field type='email' name='email' label='E-mail' component={campotexto} />
                            <OnBlur name='email'>
                                {() => {
                                    handleEmail(form);
                                }}
                            </OnBlur>
                            {email_valido===false?                                                                   
                                <Alert variant="danger">Este e-mail já esta cadastrado!</Alert>:
                                null
                            }
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <Field type='password' name='password' label='Senha' component={campotexto} />        
                        </FormLayout.Row>                        
                        <FormLayout.Row>                            
                            <Button                                
                                size="lg" 
                                block 
                                type="submit"
                                disabled={email_valido===true&&Object.keys(errors).length===0?false:true}
                                >
                                {props.pendingTasks?
                                    <Spinner animation="border"  />
                                    :
                                    "Confirmar"
                                }
                            </Button>
                            <Button                                
                                size="lg" 
                                block 
                                type="button"
                                onClick={() => (props.history.go('-1'))}
                                >
                                Voltar
                            </Button>        
                        </FormLayout.Row>
                        </>
                        }
                    </form>                    
                )
            }}
        />        
    )
}

const mapStateToProps = (state) => {
    return {
        pesquisaLogin: state.pesquisaloginGereReducer,
        pendingTasks: state.pendingTasks,
    }
}

export default connect(mapStateToProps,{pesquisa, novoatualiza})(withRouter(FormCadastro));